import { format } from 'date-fns';

export interface DateRange {
  startDate: string;
  endDate: string;
}

// Default date range: last 30 days
const getDefaultDateRange = (): DateRange => ({
  startDate: format(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd'),
  endDate: format(new Date(), 'yyyy-MM-dd'),
});

export const loadDateRange = (key: string): DateRange => {
  try {
    const savedRange = localStorage.getItem(key);
    if (!savedRange) return getDefaultDateRange();
    
    const range = JSON.parse(savedRange) as DateRange;
    range.endDate = format(new Date(), 'yyyy-MM-dd');
    // Validate the loaded dates
    if (!range.startDate || !range.endDate || 
        !Date.parse(range.startDate) || !Date.parse(range.endDate)) {
      return getDefaultDateRange();
    }
    return range;
  } catch {
    return getDefaultDateRange();
  }
};

export const saveDateRange = (key: string, dateRange: DateRange): void => {
  localStorage.setItem(key, JSON.stringify(dateRange));
};
